import {loadStringFromStorage, saveStringToLocalStorage} from "../services/localStorageService";

const LOCAL_STORAGE_LAST_COMPANY_ID_KEY = "lastCompanyId";

export const loadLastCompanyId = () => {
    const storedValue = loadStringFromStorage(LOCAL_STORAGE_LAST_COMPANY_ID_KEY, "");
    return storedValue !== "" ? storedValue : undefined;
};

export const saveLastCompanyId = (companyId: string) => {
    saveStringToLocalStorage(LOCAL_STORAGE_LAST_COMPANY_ID_KEY, companyId);
};
